import React, { Fragment } from 'react';
import { Slideshow, Intro, slideTextTypes, slideTypes } from 'dea-core';
import img1 from '../../assets/images/U1-T1-01A_R.svg';
import img2 from '../../assets/images/U1-T1-01B_U.svg';
import img3 from '../../assets/images/U1-T1-01C_L.svg';
import audio1 from '../../assets/vo/Opioid-M-One-01-NEW.mp3';
import audio2 from '../../assets/vo/Opioid-M-One-01A-NEW.mp3';
import audio3 from '../../assets/vo/Opioid-M-One-01C.mp3';

const slides = [
  {
    SlideType: slideTypes.HorizontalPan,
    panDirection: 'left',
    duration: 8,
    image: img1,
    text: {
      type: slideTextTypes.BottomText,
      text: 'Operation Prevention Workplace Modules'
    },
    vo: {
      sources: [
        {
          src: audio1
        }
      ],
      transcript:
        'Hello! Welcome! Thank you for joining us in this first of four Operation Prevention Workplace Modules.'
    }
  },
  {
    SlideType: slideTypes.VerticalPan,
    panDirection: 'up',
    duration: 15.1,
    image: img2,
    text: {
      type: slideTextTypes.BottomText,
      text: '“Knowledge is power.” – Francis Bacon'
    },
    vo: {
      sources: [
        {
          src: audio2
        }
      ],
      transcript:
        'The overall goal of the four-module series is to help you better understand the opioid epidemic, learn the facts, identify resources of support and treatment, and to get ahead of the game by practicing primary prevention.'
    }
  },
  // {
  //   SlideType: slideTypes.HorizontalPan,
  //   panDirection: 'right',
  //   duration: 0.1,
  //   image: img3,
  //   text: {
  //     type: slideTextTypes.BottomText,
  //     text: 'The Opioid Epidemic'
  //   },
  //   vo: {
  //     sources: [
  //       {
  //         src: audio3
  //       }
  //     ],
  //     transcript:
  //       'In this first module, we will be investigating what opioids are and how the epidemic evolved.'
  //   }
  // },
  {
    SlideType: slideTypes.HorizontalPan,
    panDirection: 'left',
    duration: 15,
    image: img3,
    text: {
      type: slideTextTypes.BottomText,
      text:
        'It’s more than statistics, definitions, and a timeline of factors...'
    },
    vo: {
      sources: [
        {
          src: audio3
        }
      ],
      transcript:
        'But the opioid epidemic is more than a pile of statistics, definitions, or a timeline of factors. Rather,' +
        ' it is a lived experience that impacts family, friends, work, and community.'
    }
  }
];

export default {
  title: 'The Opioid Epidemic',
  path: '/engage/the-opioid-epidemic',
  content: (
    <Fragment>
      <Intro
        direction="Select the play button below to begin."
        title="The Opioid Epidemic"
      />
      <Slideshow slides={slides} />
    </Fragment>
  )
};



// WEBPACK FOOTER //
// ./src/data/engage/Setup.js